import React from 'react';
import { CustomizeHomePageDrawer } from '@sde/widgets-core/src/widgets/CustomizeHomePageDrawer';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { useModal } from '@src/state/modal';
import PropTypes from 'prop-types';

export const CustomizeHomePageDrawerWidget = ({
  setWidgetTabsOrder,
  setIsTabPreferencesLoading,
}) => {
  const { user } = useUser.state();
  const { modals } = useModal.state();
  const { toggleModal } = useModal.actions();

  const isFlyoutOpen = !!modals.customizeHomePage;
  const setIsFlyoutOpen = (isOpen) => {
    toggleModal({ key: 'customizeHomePage', isOpen });
  };

  const widgetProps = {
    data: {
      isFlyoutOpen,
      setIsFlyoutOpen,
      user,
      setWidgetTabsOrder,
      setIsTabPreferencesLoading,
    },
  };

  return <CustomizeHomePageDrawer {...widgetProps} />;
};

CustomizeHomePageDrawerWidget.propTypes = {
  setWidgetTabsOrder: PropTypes.func.isRequired,
  setIsTabPreferencesLoading: PropTypes.func.isRequired,
};
